import { AbstractControl } from '@angular/forms';
import { Guid, isEmptyString, isNil, Nillable } from '@web/utils';
import { map, Observable, of, startWith, switchMap } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { AdminWarehouseGoodDataSourceService } from '../services/admin-warehouse-good-data-source.service';

export const adminWarehouseGoodCurrentSelectItem = (options: {
  control: AbstractControl<Nillable<Guid>>;
  dataSource: AdminWarehouseGoodDataSourceService;
}): Observable<Nillable<SelectItem<Guid>>> => {
  const { control, dataSource } = options;

  return control.valueChanges.pipe(
    startWith(control.value),
    switchMap((id) => {
      if (!isNil(id) && !isEmptyString(id)) {
        return dataSource
          .fetchDetailsById(id)
          .pipe(map((item) => new SelectItem(item.name, item.id)));
      }

      return of(null);
    }),
  );
};
